import { Suspense } from 'react'

const LoadableSuspense = (Component) =>
	function Load(props) {
		return (
			<Suspense fallback={null}>
				<Component {...props} />
			</Suspense>
		)
	}

export default LoadableSuspense
